module.exports = __webpack_public_path__ + "img/microsoft_logo.363fdd53.svg";